(function () {
  /*
   * The charity-selector snippet may appear in both
   * the quick cart and the full cart. Prevent the
   * controller from being initialized more than once.
   */
  if (window.__charitySelectorInitialized) {
    return;
  }

  window.__charitySelectorInitialized = true;

  class CharitySelector {
    constructor() {
      this.pendingUpdate = null;

      this.handleChange =
        this.handleChange.bind(this);

      this.handleCheckout =
        this.handleCheckout.bind(this);

      document.addEventListener(
        "change",
        this.handleChange
      );

      document.addEventListener(
        "click",
        this.handleCheckout,
        true
      );
    }

    getShopifyRoot() {
      if (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      ) {
        return window.Shopify.routes.root;
      }

      return "/";
    }

    getCharityFromCard(card) {
      if (!card) {
        return null;
      }

      return {
        charity_id:
          card.dataset.charityId || "",
        charity_slug:
          card.dataset.charitySlug || "",
        charity_name:
          card.dataset.charityName || ""
      };
    }

    getSelectedCharity(selector) {
  if (!selector) {
    return null;
  }

  const selectedRadio =
    selector.querySelector(
      'input[name="selected_charity"]:checked'
    );

  if (!selectedRadio) {
    return null;
  }

  const card =
    selectedRadio.closest(
      ".charity-card"
    );

  return this.getCharityFromCard(
    card
  );
}

    async handleChange(event) {
      if (
        !event.target.matches(
          'input[name="selected_charity"]'
        )
      ) {
        return;
      }

      const card =
        event.target.closest(
          ".charity-card"
        );

      const charity =
        this.getCharityFromCard(card);

      if (
        !charity ||
        !charity.charity_id
      ) {
        return;
      }

      this.saveToLocalStorage(charity);
      this.hideValidationErrors();

      /*
       * Save the charity immediately when selected.
       * Keep the promise so checkout can wait for it.
       */
      this.pendingUpdate =
        this.saveCharityToCart(charity);

      try {
        await this.pendingUpdate;
      } catch (error) {
        console.error(
          "Unable to save charity selection.",
          error
        );

        this.showValidationError(
          "We could not save your charity selection. Please select it again.",
          this.findVisibleSelector()
        );
      } finally {
        this.pendingUpdate = null;
      }
    }

    async handleCheckout(event) {
      const checkoutButton =
        event.target.closest(
          "[data-buy-now-button], " +
          'a[href^="/checkout"], ' +
          'button[name="checkout"], ' +
          'input[name="checkout"]'
        );

      if (!checkoutButton) {
        return;
      }

      const selector =
        this.findSelectorForButton(
          checkoutButton
        );

      const charity =
  this.getSelectedCharity(
    selector
  );

      /*
       * Block checkout when no charity is selected.
       */
      if (
        !charity ||
        !charity.charity_id
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        this.showValidationError(
          "Please choose a charity before continuing to checkout.",
          selector
        );

        return;
      }

      /*
       * Always take control of the standard checkout
       * click. This avoids depending on form submitter
       * state and prevents Spark from interfering.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      this.hideValidationErrors();

      const originalValue =
        checkoutButton.value;

      const originalText =
        checkoutButton.textContent;

      checkoutButton.disabled = true;
      checkoutButton.setAttribute(
        "aria-disabled",
        "true"
      );

      if (
        checkoutButton.tagName === "INPUT"
      ) {
        checkoutButton.value =
          "Saving charity...";
      } else {
        checkoutButton.textContent =
          "Saving charity...";
      }

      try {
        /*
         * If a selection update is still running,
         * wait for it. Otherwise save once more before
         * checkout to guarantee the current cart has
         * the correct properties.
         */
        if (this.pendingUpdate) {
          await this.pendingUpdate;
        } else {
          await this.saveCharityToCart(
            charity
          );
        }

        /*
         * Go directly to Shopify checkout after all
         * cart attributes and properties are saved.
         */
        window.location.assign(
          "/checkout"
        );
      } catch (error) {
        console.error(
          "Unable to continue to checkout.",
          error
        );

        checkoutButton.disabled = false;
        checkoutButton.removeAttribute(
          "aria-disabled"
        );

        if (
          checkoutButton.tagName === "INPUT"
        ) {
          checkoutButton.value =
            originalValue;
        } else {
          checkoutButton.textContent =
            originalText;
        }

        this.showValidationError(
          "We could not save your charity selection. Please select it again.",
          selector
        );
      }
    }

    async saveCharityToCart(charity) {
      const root =
        this.getShopifyRoot();

      /*
       * Read the current cart so existing line-item
       * properties can be preserved.
       */
      const cartResponse =
        await fetch(
          root + "cart.js",
          {
            method: "GET",
            credentials: "same-origin",
            headers: {
              Accept:
                "application/json"
            }
          }
        );

      if (!cartResponse.ok) {
        throw new Error(
          "Unable to read cart: " +
          cartResponse.status
        );
      }

      const cart =
        await cartResponse.json();

      /*
       * Save order-level cart attributes.
       */
      const attributeResponse =
        await fetch(
          root + "cart/update.js",
          {
            method: "POST",
            credentials:
              "same-origin",
            headers: {
              "Content-Type":
                "application/json",
              Accept:
                "application/json"
            },
            body: JSON.stringify({
              attributes: {
                selected_charity_id:
                  charity.charity_id,
                selected_charity_slug:
                  charity.charity_slug,
                selected_charity_name:
                  charity.charity_name
              }
            })
          }
        );

      if (!attributeResponse.ok) {
        throw new Error(
          "Unable to update cart attributes: " +
          attributeResponse.status
        );
      }

      /*
       * Add the charity to every cart line while
       * preserving any existing line-item properties.
       */
      for (
        let index = 0;
        index < cart.items.length;
        index += 1
      ) {
        const item =
          cart.items[index];

        const properties =
  Object.assign(
    {},
    item.properties || {}
  );

/*
 * Remove the previous public property names so they
 * do not continue appearing at checkout.
 */
delete properties.selected_charity_id;
delete properties.selected_charity_slug;
delete properties.selected_charity_name;

/*
 * Private Shopify line-item properties begin with
 * an underscore. Shopify hides these at checkout.
 */
properties._selected_charity_id =
  charity.charity_id;

properties._selected_charity_slug =
  charity.charity_slug;

properties._selected_charity_name =
  charity.charity_name;

        const lineResponse =
          await fetch(
            root + "cart/change.js",
            {
              method: "POST",
              credentials:
                "same-origin",
              headers: {
                "Content-Type":
                  "application/json",
                Accept:
                  "application/json"
              },
              body: JSON.stringify({
                id: item.key,
                properties:
                  properties
              })
            }
          );

        if (!lineResponse.ok) {
          throw new Error(
            "Unable to update cart item: " +
            lineResponse.status
          );
        }
      }

      return true;
    }

    saveToLocalStorage(charity) {
      try {
        localStorage.setItem(
          "selected_charity",
          JSON.stringify(charity)
        );
      } catch (error) {
        console.warn(
          "Unable to save charity locally.",
          error
        );
      }
    }

    findSelectorForButton(
      checkoutButton
    ) {
      const cartForm =
        checkoutButton.closest("form");

      if (cartForm) {
        const formSelector =
          cartForm.querySelector(
            ".charity-selector"
          );

        if (formSelector) {
          return formSelector;
        }
      }

      const quickCart =
        checkoutButton.closest(
          ".quick-cart"
        );

      if (quickCart) {
        const quickCartSelector =
          quickCart.querySelector(
            ".charity-selector"
          );

        if (quickCartSelector) {
          return quickCartSelector;
        }
      }

      return this.findVisibleSelector();
    }

    findVisibleSelector() {
      const selectors =
        document.querySelectorAll(
          ".charity-selector"
        );

      for (
        let index = 0;
        index < selectors.length;
        index += 1
      ) {
        const selector =
          selectors[index];

        if (
          selector.offsetWidth ||
          selector.offsetHeight ||
          selector.getClientRects().length
        ) {
          return selector;
        }
      }

      return selectors.length
        ? selectors[0]
        : null;
    }

    hideValidationErrors() {
      document
        .querySelectorAll(
          "[data-charity-error]"
        )
        .forEach(function (
          errorElement
        ) {
          errorElement.classList.remove(
            "is-visible"
          );
        });

      document
        .querySelectorAll(
          ".charity-card"
        )
        .forEach(function (card) {
          card.classList.remove(
            "charity-card--invalid"
          );
        });
    }

    showValidationError(
      message,
      selector
    ) {
      const activeSelector =
        selector ||
        this.findVisibleSelector();

      if (!activeSelector) {
        return;
      }

      const errorElement =
        activeSelector.querySelector(
          "[data-charity-error]"
        );

      if (errorElement) {
        errorElement.textContent =
          message;

        errorElement.classList.add(
          "is-visible"
        );
      }

      activeSelector
        .querySelectorAll(
          ".charity-card"
        )
        .forEach(function (card) {
          card.classList.add(
            "charity-card--invalid"
          );
        });

      activeSelector.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }

  new CharitySelector();
})();
(function () {
  /*
   * Prevent duplicate initialization because the charity
   * selector is rendered in both the quick cart and full cart.
   */
  if (
    window.__charityPropertyCleanupInitialized
  ) {
    return;
  }

  window.__charityPropertyCleanupInitialized =
    true;

  const propertySelector =
    ".quick-cart__item-properties";

  const hiddenPropertyPrefix =
    "selected_charity_";

  function removeCharityPropertyRows(
    root = document
  ) {
    const propertyRows = [];

    /*
     * Include the root itself when it is a property row.
     */
    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches(propertySelector)
    ) {
      propertyRows.push(root);
    }

    /*
     * Include property rows contained inside the root.
     */
    if (root.querySelectorAll) {
      propertyRows.push(
        ...root.querySelectorAll(
          propertySelector
        )
      );
    }

    propertyRows.forEach(
  propertyRow => {
    const propertyText =
      (
        propertyRow.textContent ||
        ""
      )
        .trim()
        .toLowerCase()
        .replace(/^_+/, "");

    if (
      propertyText.startsWith(
        hiddenPropertyPrefix
      )
    ) {
      propertyRow.remove();
    }
  }
);
}

function cleanQuickCart() {
    removeCharityPropertyRows(
      document
    );
  }

  /*
   * Clean the initial page.
   */
  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      cleanQuickCart,
      {
        once: true
      }
    );
  } else {
    cleanQuickCart();
  }

  /*
   * Clean again when Shopify refreshes the cart.
   */
  document.addEventListener(
    "cart:updated",
    function () {
      requestAnimationFrame(
        cleanQuickCart
      );
    }
  );

  /*
   * Clean restored pages when returning from checkout.
   */
  window.addEventListener(
    "pageshow",
    function () {
      requestAnimationFrame(
        cleanQuickCart
      );
    }
  );

  /*
   * Spark recreates quick-cart item markup dynamically.
   * Observe new markup and remove internal charity rows
   * whenever they are inserted.
   */
  const observer =
    new MutationObserver(
      function (mutations) {
        mutations.forEach(
          function (mutation) {
            mutation.addedNodes.forEach(
              function (addedNode) {
                if (
                  addedNode.nodeType !== 1
                ) {
                  return;
                }

                removeCharityPropertyRows(
                  addedNode
                );
              }
            );
          }
        );
      }
    );

  function startObserver() {
    if (!document.body) {
      return;
    }

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener(
      "DOMContentLoaded",
      startObserver,
      {
        once: true
      }
    );
  }
})();